import "./HomeCard.css";

import { Card, Carousel } from "react-bootstrap";
import { React, useState } from "react";

import { Link } from "react-router-dom";
import { RiBuilding2Fill } from "react-icons/ri";
import { FaBath, FaBed } from "react-icons/fa";

function HomeCard({ id, price, location, features, title, images }) {
  const [index, setIndex] = useState();

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Link to={`/living-places/${id}`}>
      <Card className="rounded mx-auto home-card" style={{ width: "18rem" }}>
        <Card.Header className="p-0">
          <Carousel
            interval={null}
            indicators={false}
            activeIndex={index}
            onSelect={handleSelect}
          >
            {images.map((imageUrl) => (
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={imageUrl}
                  alt="carousel-img"
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </Card.Header>
        <Card.Body>
          <Card.Title className="text-dark title-home-card ellipsis">
            {title}
          </Card.Title>
          <Card.Text className="text-muted mb-1">
            {location.city}, {location.country}
          </Card.Text>
          <div className="d-flex text-dark align-items-center my-3">
            <RiBuilding2Fill size={20} />
            <span className="ms-2 me-3">{features.m2} m2 </span> .
            <FaBed size={20} />
            <span className="ms-2 me-3">{features.bedrooms}</span> .
            <FaBath height={20} width={20} />
            <span className="ms-2 me-3">{features.bathrooms}</span>
          </div>
          <Card.Text className="text-dark text-home-card">
            €{price} / Month
          </Card.Text>
        </Card.Body>
      </Card>
    </Link>
  );
}

export default HomeCard;
